import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PasLayoutContentWrapperComponent, PasPageContentWrapperComponent } from '@porsche-aftersales/frontend-toolbox';

@Component({
  selector: 'tur-content',
  templateUrl: './content.component.html',
  imports: [PasPageContentWrapperComponent, PasLayoutContentWrapperComponent, RouterOutlet],
})
export class ContentComponent {}
